import { APPLICATION_QUESTION_TEMPLATE_MODEL } from "@/models/application-question-template-model";
import JSONApiService from "@/services/JSONApiService";
import { include, OPTIONS } from "@/models/relationships";

const organisationInterviewTemplateApi = commit => ({
  getAll: params =>
    JSONApiService(commit)
      .all(APPLICATION_QUESTION_TEMPLATE_MODEL)
      .get({ ...include(OPTIONS), ...params }),
  add: data =>
    JSONApiService(commit).create(APPLICATION_QUESTION_TEMPLATE_MODEL, data),
  edit: data =>
    JSONApiService(commit)
      .one(APPLICATION_QUESTION_TEMPLATE_MODEL, data.id)
      .patch(data)
});

export default organisationInterviewTemplateApi;
